<template>
  <div>
    <div class="crm-flowbar">
      <router-link class="crm-back" :to="backTo">{{ backLabel }}</router-link>
    </div>

    <div v-if="phase === 'prize'">
      <p class="crm-kicker">Qualification stand</p>
      <h1 class="crm-title">Instant gagnant</h1>
      <CrmSalonPrizeWheel
        v-if="prospectId"
        :prospect-id="prospectId"
        :prenom="form.prenom"
        :email="form.email"
        :telephone="form.telephone"
        :origin="origin"
        @won="onPrizeWon"
        @skip="goReturn"
        @done="goReturn"
        @sent="onPrizeSent"
      />
    </div>

    <div v-else>
      <p class="crm-kicker">Qualification stand</p>
      <h1 class="crm-title">Qualification</h1>
      <div class="crm-steps-meta">
        <strong>Étape {{ step }} sur 7</strong>
        <span>mobile-first</span>
      </div>
      <div class="crm-steps"><i v-for="n in 7" :key="'st' + n" :class="{ on: n <= step }"></i></div>

      <div class="crm-card" v-if="step === 1">
        <div class="crm-field"><label class="crm-label">Prénom</label><input class="crm-input" v-model="form.prenom" /></div>
        <div class="crm-field"><label class="crm-label">Nom</label><input class="crm-input" v-model="form.nom" /></div>
        <div class="crm-field"><label class="crm-label">Cabinet / société</label><input class="crm-input" v-model="form.societe" /></div>
        <div class="crm-field"><label class="crm-label">Téléphone</label><input class="crm-input" v-model="form.telephone" /></div>
        <div class="crm-field"><label class="crm-label">Email</label><input class="crm-input" v-model="form.email" /></div>
        <div class="crm-grid-2">
          <div class="crm-field"><label class="crm-label">N° ORIAS</label><input class="crm-input" v-model="form.orias" placeholder="ex. 07001234" /></div>
          <div class="crm-field"><label class="crm-label">Ville</label><input class="crm-input" v-model="form.ville" placeholder="ex. Quimper" /></div>
        </div>
      </div>

      <div class="crm-card" v-if="step === 2">
        <label class="crm-label">Type de partenaire</label>
        <div class="crm-chips">
          <button v-for="p in partners" :key="p.id" type="button" class="crm-chip" :class="{ on: form.partner_type === p.id }" @click="form.partner_type = p.id">{{ p.label }}</button>
        </div>
        <div v-if="needsSize" style="margin-top:12px">
          <label class="crm-label">Taille de structure</label>
          <div class="crm-chips">
            <button v-for="s in sizes" :key="s.id" type="button" class="crm-chip" :class="{ on: form.structure_size === s.id }" @click="form.structure_size = s.id">{{ s.label }}</button>
          </div>
          <label class="crm-label" style="margin-top:12px">Mode de vente</label>
          <div class="crm-chips">
            <button
              v-for="w in workModes"
              :key="w.id"
              type="button"
              class="crm-chip"
              :class="{ on: workModeOn(w.id) }"
              @click="toggleWorkMode(w.id)"
            >{{ w.label }}</button>
          </div>
          <div v-if="workModeOn('vad')" class="crm-field" style="margin-top:12px">
            <label class="crm-label">Pays VAD</label>
            <select class="crm-select" v-model="form.vad_country">
              <option value="">—</option>
              <option v-for="c in countries" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="crm-card" v-if="step === 3">
        <label class="crm-label">Courtier en</label>
        <div class="crm-chips">
          <button v-for="p in products" :key="p.id" type="button" class="crm-chip" :class="{ on: productOn(p.id) }" @click="toggleProduct(p.id)">{{ p.label }}</button>
        </div>
        <label class="crm-label" style="margin-top:12px">Nouveautés salon</label>
        <div class="crm-chips">
          <button v-for="o in offers" :key="o.id" type="button" class="crm-chip" :class="{ on: offerOn(o.id) }" @click="toggleOffer(o.id)">{{ o.label }}</button>
        </div>
        <div class="crm-field" style="margin-top:12px">
          <label class="crm-label">Autre</label>
          <input class="crm-input" v-model="form.product_other" />
        </div>
      </div>

      <div class="crm-card" v-if="step === 4">
        <label class="crm-label">Achète des leads ?</label>
        <div class="crm-chips">
          <button v-for="b in buys" :key="b.id" type="button" class="crm-chip" :class="{ on: form.buys_leads === b.id }" @click="form.buys_leads = b.id">{{ b.label }}</button>
        </div>
        <label class="crm-label" style="margin-top:12px">Budget mensuel</label>
        <div class="crm-chips">
          <button v-for="b in budgets" :key="b.id" type="button" class="crm-chip" :class="{ on: form.budget_band === b.id }" @click="form.budget_band = b.id">{{ b.label }}</button>
        </div>
      </div>

      <div class="crm-card" v-if="step === 5">
        <label class="crm-label">Typologie attendue</label>
        <div class="crm-chips">
          <button v-for="t in leadTypes" :key="t.id" type="button" class="crm-chip" :class="{ on: form.lead_type === t.id }" @click="form.lead_type = t.id">{{ t.label }}</button>
        </div>
        <div v-if="form.lead_type && market[form.lead_type]" class="crm-hint" style="margin-top:8px">
          Repère marché : {{ market[form.lead_type].price }} · {{ market[form.lead_type].conv }}
        </div>
        <label class="crm-label" style="margin-top:12px">Prix évoqué</label>
        <div class="crm-chips">
          <button v-for="p in prices" :key="p.id" type="button" class="crm-chip" :class="{ on: form.price_band === p.id }" @click="form.price_band = p.id">{{ p.label }}</button>
        </div>
        <label class="crm-label" style="margin-top:12px">Taux conver.</label>
        <div class="crm-chips">
          <button v-for="c in convs" :key="c.id" type="button" class="crm-chip" :class="{ on: form.conv_band === c.id }" @click="form.conv_band = c.id">{{ c.label }}</button>
        </div>
        <div v-if="copilot.verdict === 'charlot'" class="crm-card warn" style="margin-top:12px;margin-bottom:0">
          Attentes à recadrer en douceur — tirage quand même autorisé.
        </div>
      </div>

      <div class="crm-card" v-if="step === 6">
        <label class="crm-label">CRM / outil métier</label>
        <div class="crm-chips">
          <button v-for="c in crms" :key="c.id" type="button" class="crm-chip" :class="{ on: form.crm_key === c.id }" @click="form.crm_key = c.id">{{ c.label }}</button>
        </div>
      </div>

      <div class="crm-card" v-if="step === 7">
        <div class="crm-field">
          <label class="crm-label">Note</label>
          <textarea class="crm-textarea" v-model="form.note_interne"></textarea>
        </div>
        <div class="crm-field">
          <label class="crm-label">Score manuel 1–5</label>
          <div class="crm-chips">
            <button v-for="n in 5" :key="'sm' + n" type="button" class="crm-chip" :class="{ on: form.score_manuel === n }" @click="form.score_manuel = n">{{ n }}</button>
          </div>
        </div>
        <div class="crm-field">
          <label class="crm-label">Intérêt / piste</label>
          <div class="crm-chips">
            <button v-for="n in 5" :key="'in' + n" type="button" class="crm-chip" :class="{ on: form.interest === n }" @click="form.interest = n">{{ n }}</button>
            <button type="button" class="crm-chip" :class="{ on: form.interest === 0 }" @click="form.interest = 0">Aucun</button>
          </div>
        </div>
        <div class="crm-hint">Copilote : {{ copilot.score }}/5 · {{ copilot.verdict }}</div>
        <div class="crm-field">
          <label class="crm-label">Prochaine action</label>
          <select class="crm-select" v-model="form.next_action">
            <option value="">—</option>
            <option value="rdv">RDV pris</option>
            <option value="email">Email immédiat</option>
            <option value="acces">Créer un accès</option>
            <option value="appel">Appel prioritaire</option>
            <option value="plus-tard">Plus tard</option>
          </select>
        </div>
        <div v-if="form.next_action === 'rdv'">
          <div class="crm-grid-2">
            <div class="crm-field"><label class="crm-label">Jour</label><input class="crm-input" type="date" v-model="rdvDay" /></div>
            <div class="crm-field"><label class="crm-label">Heure</label><input class="crm-input" type="time" v-model="rdvTime" /></div>
          </div>
          <label class="crm-label">Confirmation</label>
          <div class="crm-chips">
            <button type="button" class="crm-chip" :class="{ on: rdvChannel === 'whatsapp' }" @click="rdvChannel = 'whatsapp'">WhatsApp</button>
            <button type="button" class="crm-chip" :class="{ on: rdvChannel === 'sms' }" @click="rdvChannel = 'sms'">SMS</button>
            <button type="button" class="crm-chip" :class="{ on: rdvChannel === 'email' }" @click="rdvChannel = 'email'">E-mail</button>
          </div>
        </div>
      </div>

      <div class="crm-sticky-footer">
        <button type="button" class="crm-btn crm-btn-outline" :disabled="step <= 1" @click="prevStep">Retour</button>
        <button type="button" class="crm-btn crm-btn-primary crm-btn-lg" @click="next" :disabled="saving">
          {{ step === 7 ? (saving ? '…' : 'Enregistrer') : 'Continuer' }}
        </button>
      </div>
      <p v-if="msg" class="crm-hint" style="margin-top:10px">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
import {
  PARTNERS, WORK_MODES, SIZES, VAD_COUNTRIES, PRODUCTS, OFFERS, BUYS, BUDGETS,
  LEAD_TYPES, PRICES, CONVS, CRMS, MARKET, computeCopilot, parseJsonField,
  parseWorkModes, serializeWorkModes, salonReturnTo, salonReturnLabel, withFrom
} from './crmSalonUtils'
import { invalidateJourneeCache } from './crmSalonCache'
import CrmSalonPrizeWheel from './CrmSalonPrizeWheel.vue'

export default {
  name: 'CrmSalonQualifier',
  components: { CrmSalonPrizeWheel },
  data() {
    return {
      step: 1,
      phase: 'form',
      origin: 'nouveau',
      alreadyWon: false,
      prizeId: null,
      prospectId: this.$route.query.id || null,
      partners: PARTNERS,
      workModes: WORK_MODES,
      sizes: SIZES,
      countries: VAD_COUNTRIES,
      products: PRODUCTS,
      offers: OFFERS,
      buys: BUYS,
      budgets: BUDGETS,
      leadTypes: LEAD_TYPES,
      prices: PRICES,
      convs: CONVS,
      crms: CRMS,
      market: MARKET,
      productsSel: [],
      offersSel: [],
      workModesSel: [],
      form: {
        prenom: '', nom: '', societe: '', telephone: '', email: '', orias: '', ville: '',
        partner_type: '', work_mode: '', vad_country: '', structure_size: '',
        product_other: '', buys_leads: '', budget_band: '', lead_type: '',
        price_band: '', conv_band: '', crm_key: '', note_interne: '',
        score_manuel: null, interest: null, next_action: ''
      },
      rdvDay: '',
      rdvTime: '',
      rdvChannel: 'whatsapp',
      saving: false,
      msg: ''
    }
  },
  computed: {
    backTo() {
      const from = salonReturnTo(this.$route, '')
      if (from) return from
      if (this.prospectId) {
        return withFrom('/crm-salon/fiche/' + this.prospectId, this.$route.query.from)
      }
      return '/crm-salon'
    },
    backLabel() {
      return salonReturnLabel(this.backTo)
    },
    needsSize() {
      return ['courtier', 'agent', 'mutuelle', 'assureur'].indexOf(this.form.partner_type) >= 0
    },
    copilot() {
      return computeCopilot({
        buys_leads: this.form.buys_leads,
        budget_band: this.form.budget_band,
        crm_key: this.form.crm_key,
        price_band: this.form.price_band,
        conv_band: this.form.conv_band,
        lead_type: this.form.lead_type
      })
    }
  },
  async mounted() {
    if (this.prospectId) {
      try {
        await this.load()
      } catch (e) {
        this.msg = (e && e.message) || 'Chargement impossible'
      }
    }
  },
  methods: {
    productOn(id) { return this.productsSel.indexOf(id) >= 0 },
    offerOn(id) { return this.offersSel.indexOf(id) >= 0 },
    workModeOn(id) { return this.workModesSel.indexOf(id) >= 0 },
    toggleProduct(id) {
      const i = this.productsSel.indexOf(id)
      if (i >= 0) this.productsSel.splice(i, 1)
      else this.productsSel.push(id)
    },
    toggleOffer(id) {
      const i = this.offersSel.indexOf(id)
      if (i >= 0) this.offersSel.splice(i, 1)
      else this.offersSel.push(id)
    },
    toggleWorkMode(id) {
      const i = this.workModesSel.indexOf(id)
      if (i >= 0) this.workModesSel.splice(i, 1)
      else this.workModesSel.push(id)
      if (!this.workModeOn('vad')) this.form.vad_country = ''
    },
    prevStep() {
      if (this.step > 1) this.step = this.step - 1
    },
    async load() {
      const { data } = await this.$apollo.query({
        client: 'AUTH',
        query: require('src/graphql/auth/crmSalon/crmSalonFiche.gql'),
        variables: { id: String(this.prospectId) },
        fetchPolicy: 'network-only'
      })
      const f = data.crmSalonFiche
      if (!f) return
      Object.keys(this.form).forEach(k => {
        if (f[k] != null) this.form[k] = f[k]
      })
      // Chips attendent des nombres
      if (this.form.score_manuel != null) this.form.score_manuel = Number(this.form.score_manuel)
      if (this.form.interest != null) this.form.interest = Number(this.form.interest)
      this.productsSel = parseJsonField(f.products_json, [])
      this.offersSel = parseJsonField(f.offers_json, [])
      this.workModesSel = parseWorkModes(f.work_mode)
      this.origin = f.origin || 'nouveau'
      this.alreadyWon = !!(f.prizes && f.prizes.length)
      if (this.alreadyWon) this.prizeId = f.prizes[0].id
    },
    prizeEligible() {
      return !this.alreadyWon && (this.origin === 'nouveau' || this.origin === 'inactif')
    },
    goReturn() {
      const to = salonReturnTo(this.$route, this.prospectId
        ? '/crm-salon/fiche/' + this.prospectId
        : '/crm-salon')
      this.$router.push(to)
    },
    onPrizeWon(payload) {
      if (payload && payload.prizeId) this.prizeId = payload.prizeId
    },
    async onPrizeSent(channel) {
      if (!this.prizeId) return
      try {
        await this.$apollo.mutate({
          client: 'AUTH',
          mutation: require('src/graphql/auth/crmSalon/crmSalonMarkPrizeSent.gql'),
          variables: { prize_id: String(this.prizeId), channel }
        })
      } catch (e) { /* ignore */ }
    },
    async next() {
      if (this.step < 7) {
        this.step = this.step + 1
        return
      }
      if (!this.prospectId) {
        this.msg = 'Prospect manquant — revenir à la fiche.'
        return
      }
      this.saving = true
      this.msg = ''
      try {
        const co = this.copilot
        const variables = {
          id: String(this.prospectId),
          ...this.form,
          work_mode: serializeWorkModes(this.workModesSel) || null,
          score_manuel: this.form.score_manuel == null || this.form.score_manuel === ''
            ? null
            : Number(this.form.score_manuel),
          interest: this.form.interest == null || this.form.interest === ''
            ? null
            : Number(this.form.interest),
          products_json: JSON.stringify(this.productsSel),
          offers_json: JSON.stringify(this.offersSel),
          copilot_score: co.score,
          copilot_verdict: co.verdict,
          pipeline: 'Qualifié',
          status: 'pending',
          origin: this.origin || 'nouveau'
        }
        const { data } = await this.$apollo.mutate({
          client: 'AUTH',
          mutation: require('src/graphql/auth/crmSalon/crmSalonUpsertProspect.gql'),
          variables
        })
        const id = data.crmSalonUpsertProspect.id
        this.prospectId = id
        invalidateJourneeCache()
        if (this.form.next_action === 'rdv' && this.rdvDay) {
          await this.$apollo.mutate({
            client: 'AUTH',
            mutation: require('src/graphql/auth/crmSalon/crmSalonBookRdv.gql'),
            variables: {
              prospect_id: String(id),
              rdv_day: this.rdvDay,
              rdv_time: this.rdvTime,
              channel: this.rdvChannel,
              confirmed: false
            }
          })
        }
        if (this.prizeEligible()) {
          this.phase = 'prize'
          window.scrollTo(0, 0)
        } else {
          this.goReturn()
        }
      } catch (e) {
        this.msg = e.message || 'Erreur'
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
